<template>
  <section class="top-0 bg-gray-100 shadow-md mb-8">
    <!-- z-10 -->
    <div class="container mx-auto px-4 lg:px-16">
      <div class="mx-auto px-0 lg:divide-y lg:divide-gray-200">
        <div class="relative h-16 flex justify-between">
          <div class="flex justify-between w-full items-center">
            <!-- z-10 -->
            <div class="relative flex-1">
              <div
                class="absolute inset-y-0 left-0 flex items-center sm:hidden"
                v-click-outside="handleIsMenuOpen"
              >
                <!-- Mobile menu button -->
                <button
                  type="button"
                  class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                  aria-controls="mobile-menu"
                  aria-expanded="false"
                  @click.prevent="toggleMenuOpen"
                >
                  <span class="sr-only">Open main menu</span>
                  <svg
                    class="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div>
              <div
                class="flex-1 flex items-center sm:justify-start md:px-0 px-8"
              >
                <div
                  class="flex-shrink-0 flex items-center duration-500 rounded-lg"
                >
                  <router-link
                    :to="{ name: 'Newhome' }"
                    v-if="
                      (getToken() &&
                        localUser &&
                        localUser.user_type != GUEST) ||
                      token
                    "
                  >
                    <img
                      class="block h-8 w-auto"
                      :src="require(`@/assets/img/fitclas.png`)"
                      alt="Workflow"
                    />
                  </router-link>
                  <router-link :to="{ name: 'DashboardBeforeLogin' }" v-else>
                    <img
                      class="block h-12 w-auto"
                      :src="require(`@/assets/img/fitclas.png`)"
                      alt="Workflow"
                    />
                  </router-link>
                </div>
                <div class="hidden sm:ml-6 sm:flex sm:space-x-8 w-full">
                  <div class="w-full max-w-sm">
                    <label for="search" class="sr-only">Search</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <div
                        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      >
                        <!-- Heroicon name: solid/search -->
                        <svg
                          class="h-5 w-5 text-gray-dark"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <input
                        type="search"
                        name="search"
                        id="search"
                        class="focus:outline-none focus:ring-0 focus:outline-offset-0 block w-full pl-10 pr-24 sm:text-sm border-1 border-borderColor rounded-md h-10"
                        :placeholder="
                          searchType === 'sessions'
                            ? 'Search for sessions by keyword'
                            : 'Search for trainers by keyword'
                        "
                        v-model="searchValue"
                        v-on:keyup.enter="handleSearchSubmit"
                      />
                      <div
                        class="absolute inset-y-0 right-0 pr-0 flex items-center"
                      >
                        <label for="currency" class="sr-only">Currency</label>
                        <select
                          id="currency"
                          name="currency"
                          class="form-select border-0 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-dark sm:text-sm rounded-md focus:outline-none"
                          v-model="searchType"
                        >
                          <option value="sessions">Classes</option>
                          <option value="trainers">Trainers</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <router-link
                  :to="{ name: 'Newhome', params: { id: 'all' } }"
                  class="ml-5 xl:ml-6 lg:ml-2 text-base hover:text-green-light"
                  exact-active-class="text-green-dark"
                >
                  Home
                </router-link>
                <router-link
                  :to="{ name: 'SessionsFind', params: { id: 'all' } }"
                  class="ml-5 xl:ml-6 lg:ml-2 text-base hover:text-green-light"
                  exact-active-class="text-green-dark"
                >
                  Classes
                </router-link>
                <router-link
                  :to="{ name: 'TrainersFind', params: { id: 'all' } }"
                  class="ml-5 xl:ml-6 lg:ml-2 text-base hover:text-green-light"
                  exact-active-class="text-green-dark"
                >
                  Trainers
                </router-link>
              </div>
            </div>

            <!-- absolute -->
            <div
              class="inset-y-0 right-0 flex items-center pr-8 sm:static sm:inset-auto sm:ml-6 sm:pr-0 space-x-3"
              v-if="
                ((getToken() && localUser && localUser.user_type != GUEST) ||
                  token) &&
                $route.name !== 'DashboardBeforeLogin'
              "
            >
              <!-- Calendar dropdown -->
              <div
                class="flex-shrink-0 md:relative ml-4 h-8"
                v-click-outside="toggleCalendarDropdown"
              >
                <div>
                  <!-- tooltip -->
                  <button
                    type="button"
                    class="bg-transparent hover:text-green-light p-1 rounded-full text-gray-dark focus:outline-none flex"
                    @click="isCalendarOpen = !isCalendarOpen"
                  >
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <Calendar class="user-calendar" slot="reference" />
                      <span class="popper"> Calendar </span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 md:w-96 w-full rounded-md shadow-lg bg-white ring-gray-300 ring-opacity-5 focus:outline-none z-30"
                  v-if="isCalendarOpen"
                >
                  <MiniCalendar :type="'user'" class="mini-calendar" />
                  <div class="flex justify-center items-center uppercase">
                    <router-link
                      :to="{ name: 'UserCalendar' }"
                      class="w-full h-10 px-6 text-white transition-colors duration-150 bg-green-light rounded-b-lg focus:shadow-outline text-center py-2"
                    >
                      Open Calendar
                    </router-link>
                  </div>
                </div>
              </div>

              <!-- Chat notification dropdown -->
              <div
                class="flex-shrink-0 md:relative ml-4 h-8"
                v-click-outside="toggleChat"
              >
                <div>
                  <button
                    type="button"
                    class="bg-transparent hover:text-green-light p-1 rounded-full text-gray-dark focus:outline-none flex"
                    @click="isChatOpen = !isChatOpen"
                  >
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <ChatAlt
                        :badge="isChatIconActive"
                        :value="sendMessageSum"
                        slot="reference"
                      />
                      <span class="popper"> Chat </span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 md:w-96 w-full rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 py-1 focus:outline-none border"
                  v-if="isChatOpen"
                >
                  <ChatNotificationDropdown
                    :userType="'User'"
                    @onClose="toggleChat"
                  />
                </div>
              </div>

              <!-- Notification dropdown -->
              <div
                class="flex-shrink-0 md:relative ml-4 h-8"
                v-click-outside="closeNotification"
              >
                <div>
                  <button
                    type="button"
                    class="bg-transparent hover:text-green-light p-1 rounded-full text-gray-dark focus:outline-none flex"
                    @click="toggleNotificationDropdown"
                  >
                    <span class="sr-only">View notifications</span>
                    <!-- Heroicon name: outline/bell -->
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <Bell
                        :badge="isBellIconActive"
                        :value="joinSessionSum"
                        slot="reference"
                      />
                      <span class="popper"> Notifications </span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 md:w-96 w-full rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 py-1 focus:outline-none border"
                  v-if="isNotificationOpen"
                >
                  <NotificationDropdown
                    :userType="'User'"
                    @onClose="closeNotification"
                  />
                </div>
              </div>
               <!-- Fitclass tutorials Icon -->
               <div
                  v-if="tutorialPath && tutorialPath.length && tutorialPath !== 'undefined'"
                  class="flex-shrink-0 relative ml-3 w-8 h-10">
                <!-- tooltip -->
                <button
                  type="button"
                  class="hover:text-green-light bg-transparent p-1 rounded-full text-gray-dark focus:outline-none flex"
                  @click="redirectUrlHandler"
                >
                  <Tooltip
                    trigger="hover"
                    :options="{
                      placement: 'bottom',
                      modifiers: { offset: { offset: '0,2px' } },
                    }"
                    :forceShow="displayTurialNotifier"
                    rootClass="tutorial-popper"
                  >
                    <i class="fa fa-question-circle-o text-2xl" slot="reference"></i>
                    <span class="popper"> {{tutorialText}} </span>
                  </Tooltip>
                </button>
              </div>
              <!-- Profile dropdown -->
              <div
                class="flex-shrink-0 relative sh-8"
                v-click-outside="hideIsProfileOpen"
              >
                <div>
                  <!-- tooltip -->
                  <button
                    type="button"
                    class="bg-white rounded-full flex text-sm focus:outline-none"
                    @click.prevent="toggleProfileDropdown"
                  >
                    <span class="sr-only">Open user menu</span>
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <img
                        class="h-8 w-8 rounded-full"
                        :src="baseUrlSrc(userImage)"
                        alt=""
                        @error="defaultCircleImage"
                        slot="reference"
                      />
                      <span class="popper">Profile</span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-gray-300 ring-opacity-5 focus:outline-none z-20"
                  v-if="isProfileOpen"
                >
                  <router-link
                    :to="{ name: 'UserProfile' }"
                    class="block hover:bg-gray-200 px-4 py-2 text-sm text-gray-700"
                  >
                    Your Profile
                  </router-link>
                  <router-link
                    :to="{ name: 'UserSettings' }"
                    class="block hover:bg-gray-200 px-4 py-2 text-sm text-gray-700"
                  >
                    Settings
                  </router-link>
                  <a
                    href="javascript:void(0)"
                    class="block px-4 py-2 hover:bg-gray-200 text-sm text-gray-700"
                    @click="logoutHandler"
                  >
                    Sign out
                  </a>
                </div>
              </div>
              <!--
              <div class="relative ml-8" v-click-outside="onoutsideAsTrainer">
                <button
                  class="inline-flex items-center h-10 px-3 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none hover:bg-white ring-1 ring-gray-400 w-48 justify-center"
                  @click="onclickAsTrainer"
                >
                  <span>Seen as Attendee</span>
                  <svg class="w-4 h-4 ml-3 fill-current" viewBox="0 0 20 20">
                    <path
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                    ></path>
                  </svg>
                </button>
                <div
                  class="absolute right-0 z-20 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-400 ring-opacity-5 focus:outline-none"
                  v-if="isAsTrainer"
                >
                  <div class="py-1">
                    <a
                      href="#"
                      class="text-gray-700 block px-4 py-2 text-sm bg-gray-100"
                    >
                      Seen as Attendee
                    </a>
                    <button
                      type="button"
                      class="text-gray-700 block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                      @click="switchToTrainerProfile"
                    >
                      {{
                        getRoles.length === 0
                          ? "Become a trainer"
                          : "Seen as Trainer"
                      }}
                    </button>
                  </div>
                </div>
              </div>
              -->
              <UserRoleSelector v-if="getUser().isRoleSelected===true"></UserRoleSelector>
              <!-- <div>
                <select
                  class="mt-0 block w-ful rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-dark focus:ring-1 focus:ring-gray-dark sm:text-sm sm:leading-6 bg-white"
                  @change="switchToTrainerProfile"
                >
                  <option selected>Seen as Attendee</option>
                  <option>
                    {{
                      getRoles.length === 0
                        ? "Become a trainer"
                        : "Seen as Trainer"
                    }}
                  </option>
                </select>
              </div> -->
            </div>
            <!-- absolute -->
            <div class="flex items-center xl:ml-10 ml-5" v-else>
              <!-- <router-link
                :to="{ name: 'SessionsFind' }"
                class="text-sm text-gray-dark md:block hidden"
              >
                Explore
              </router-link> -->
              <router-link
                :to="{ name: 'Login' }"
                class="flex-shrink-0 uppercase text-sm font-semibold tracking-tight leading-5 py-2 mr-10 focus:outline-none"
              >
                Log in
              </router-link>
              <router-link
                :to="{ name: 'CompleteSignup' }"
                class="flex-shrink-0 uppercase text-sm leading-5 tracking-tight bg-green-light rounded-3xl py-2 px-8 text-white hover:text-gray-100 focus:outline-none font-semibold"
              >
                Sign Up
              </router-link>
            </div>
          </div>
        </div>

        <div class="w-full max-w-sm sm:hidden block pb-2">
          <label for="search" class="sr-only">Search</label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
            >
              <!-- Heroicon name: solid/search -->
              <svg
                class="h-5 w-5 text-gray-dark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <input
              type="search"
              name="search"
              id="search"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 pr-20 sm:text-sm ring-gray-300 rounded-md ring-1 h-10"
              :placeholder="
                searchType === 'sessions'
                  ? 'Search for sessions by keyword'
                  : 'Search for trainers by keyword'
              "
              v-model="searchValue"
              v-on:keyup.enter="handleSearchSubmit"
            />
            <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
              <label for="currency" class="sr-only">Currency</label>
              <select
                id="currency"
                name="currency"
                class="focus:ring-green-light focus:border-green-light h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-dark sm:text-sm rounded-md focus:outline-none"
                v-model="searchType"
              >
                <option value="sessions">Classes</option>
                <option value="trainers">Trainers</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <Modal v-model="isShareModalOpen" :title="'Share link to Class'">
      <div class="space-y-4">
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share link via</p>
          <ShareNetworkComponent
            :sharingUrl="sharingUrl"
            :title="
              userSessionDetail &&
              userSessionDetail.session &&
              userSessionDetail.session.details &&
              userSessionDetail.session.details.title
            "
          />
        </div>
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share this link</p>
          <div class="flex items-center">
            <input
              class="w-full h-10 px-3 text-base text-gray-700 placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
              type="text"
              placeholder="Sharing url"
              v-model="sharingUrl"
              disabled
            />
            <button
              type="button"
              class="h-10 px-4 text-sm text-green-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light w-32"
              id="copy-url"
              @click.prevent="handleCopyUrlButton"
            >
              Copy URL
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script>
import MiniCalendar from "@/components/MiniCalendar.vue";

import ChatNotificationDropdown from "@/components/notification/ChatNotificationDropdown";
import ShareNetworkComponent from "@/components/social-sharing/ShareNetworkComponent";
import NotificationDropdown from "@/components/notification/NotificationDropdown";
import { Calendar, ChatAlt, Heart, Bell } from "@/components/icons";
import { Modal } from "@/components/t-components";
import { mapActions, mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import Tooltip from "@/components/Tooltip.vue";
import UserRoleSelector from "./UserRoleSelector.vue";

export default {
  name: "UserHeader",
  components: {
    Bell,
    Heart,
    Modal,
    Calendar,
    ChatAlt,
    NotificationDropdown,
    ShareNetworkComponent,
    ChatNotificationDropdown,
    MiniCalendar,
    Tooltip,
    UserRoleSelector
},
  props: {
    data: {
      type: Array,
    },
    searchTypeList: {
      type: String,
      default: "sessions",
    },
  },
  data() {
    return {
      isMenuOpen: false,
      isProfileOpen: false,
      isCalendarOpen: false,
      heartFill: "",
      favouriteCount: 0,
      details: JSON.parse(localStorage.getItem("details")),
      localUser: JSON.parse(localStorage.getItem("user")),
      searchType: this.searchTypeList,
      searchValue: "",
      isNotificationOpen: false,
      isChatOpen: false,
      joinSessionSum: 0,
      sendMessageSum: 0,
      isChatIconActive: false,
      isBellIconActive: false,
      isShareModalOpen: false,
      sharingUrl: "",
      isAsTrainer: false,
      tutorialText: 'Tutorials',
      displayTurialNotifier: false
    };
  },
  computed: {
    ...mapGetters([
      "userProfile",
      "notifications",
      "userSessionDetail",
      "userCourseDetail",
      "token",
      "user",
      "getRoles",
      "tutorialNotified"
    ]),

    watchUserProfile() {
      return this.userProfile;
    },
    userImage () {
      return this.userProfile && this.userProfile.personal_details && this.userProfile.personal_details.thumbnail_url;
    },
    tutorialPath () {
      return window.config.VUE_APP_ATTENDEE_TUTORIAL_URL
    }
  },
  methods: {
    ...mapActions([
      "getNotifications",
      "logout",
      "getUserProfile",
      "getCategoriesList",
      "postUserSessionAddRemoveFavourite",
      "getUserSessionDetail",
      "getUserCourseDetail",
      // "switchToTrainer",
      // "getUserRoles",
      "getTrainerRoles",
    ]),

    logoutHandler() {
      this.logout()
    },

    // async switchToTrainerProfile() {
    //   store.commit("setIsLoading", true);
    //   try {
    //     await this.switchToTrainer();
    //     let user = JSON.parse(localStorage.getItem("user"));
    //     user.user_type = 2;
    //     localStorage.setItem("user", JSON.stringify(user));
    //     this.$router.push({ name: "dashboard" });
    //   } catch {
    //     console.log("Can't switch to trainer");
    //   }
    //   store.commit("setIsLoading", false);
    // },

    toggleProfileDropdown() {
      this.isProfileOpen = !this.isProfileOpen;
    },

    hideIsProfileOpen() {
      this.isProfileOpen = false;
    },

    toggleCalendarDropdown() {
      this.isCalendarOpen = false;
    },

    handleSearchSubmit() {
      if (this.searchType === "sessions") {
        this.$router.push({
          name: "SessionsFind",
          query: { type: this.searchType, filter: this.searchValue },
        });
      } else {
        this.$router.push({
          name: "TrainersFind",
          query: { type: this.searchType, filter: this.searchValue },
        });
      }
    },

    toggleNotificationDropdown() {
      this.isNotificationOpen = !this.isNotificationOpen;
    },

    closeNotification() {
      this.isNotificationOpen = false;
    },

    toggleChat() {
      this.isChatOpen = false;
    },

    sumNotifications() {
      this.notifications &&
        this.notifications.forEach((el) => {
          if (el.type == "joinSession") {
            this.joinSessionSum += el.is_active;
          } else if (el.type == "sendMessage") {
            this.sendMessageSum += el.is_active;
          } else {
            // console.log("else");
          }
        });

      if (this.joinSessionSum) {
        this.isBellIconActive = true;
      }
      if (this.sendMessageSum) {
        this.isChatIconActive = true;
      }
    },

    async handleShareButton() {
      this.isShareModalOpen = !this.isShareModalOpen;
      this.sharingUrl = this.getRouterHref(this.USERSESSIONDETAILS);
    },

    handleCopyUrlButton() {
      if (this.sharingUrl) {
        navigator.clipboard.writeText(this.sharingUrl);
        document.getElementById("copy-url").innerHTML = "Copied";
      }
    },

    // async sessionCourseFavouriteHandler() {
    //   if (this.getToken()) {
    //     let id,
    //       favourite = "no";

    //     if (this.$router.currentRoute.path.includes("user/course/details")) {
    //       id = 2;
    //       if (this.userCourseDetail.course.details.is_favourite)
    //         favourite = "no";
    //       else favourite = "yes";
    //     } else {
    //       id = this.SESSION;
    //       if (this.userSessionDetail.session.details.is_favourite)
    //         favourite = "no";
    //       else favourite = "yes";
    //     }

    //     const data = {
    //       entity_id: this.$route.params.id,
    //       entity_type: id,
    //       favourite: favourite,
    //     };
    //     await this.postUserSessionAddRemoveFavourite(data);
    //     if (id === 1) {
    //       await this.getUserSessionDetail(data.entity_id);
    //       this.heartFill =
    //         this.userSessionDetail &&
    //         this.userSessionDetail.session &&
    //         this.userSessionDetail.session.details &&
    //         this.userSessionDetail.session.details.is_favourite;
    //       this.favouriteCount =
    //         this.userSessionDetail &&
    //         this.userSessionDetail.session &&
    //         this.userSessionDetail.session.details &&
    //         this.userSessionDetail.session.details.favourite_count;
    //     } else {
    //       await this.getUserCourseDetail(data.entity_id);
    //       this.heartFill =
    //         this.userCourseDetail &&
    //         this.userCourseDetail.course &&
    //         this.userCourseDetail.course.details &&
    //         this.userCourseDetail.course.details.is_favourite;
    //       this.favouriteCount =
    //         this.userCourseDetail &&
    //         this.userCourseDetail.course &&
    //         this.userCourseDetail.course.details &&
    //         this.userCourseDetail.course.details.favourite_count;
    //     }
    //   } else {
    //     this.$router.push({
    //       name: "Login",
    //     });
    //   }
    // },

    toggleMenuOpen() {
      this.isMenuOpen = !this.isMenuOpen;
      this.$emit("is-menu-open", this.isMenuOpen);
    },

    handleIsMenuOpen() {
      this.isMenuOpen = false;
    },

    onoutsideAsTrainer() {
      this.isAsTrainer = false;
    },
    redirectUrlHandler () {
      localStorage.setItem("fitclass_tutorialAct", 'visited');
      window.open(
        this.tutorialPath,
        '_blank'
      );
    },
    checkTutorialNotifier () {
      let userTutorialAct = localStorage.getItem("fitclass_tutorialAct")
      if (!userTutorialAct && !this.tutorialNotified) {
        this.tutorialText = 'Looking for Fitclass Tutorials ?'
        this.displayTurialNotifier = true
        setTimeout(() => {
          this.displayTurialNotifier = false
          this.tutorialText = 'Tutorials'
          this.$store.commit('setTutorialNotifier', true)
        }, 5000);
      }
    }
  },
  async created() {
    const query = {
      page: this.followingCurrentPage,
    };
    this.checkTutorialNotifier()
    this.getToken() ? await this.getUserProfile({ query }) : ''
    if (this.$router.currentRoute.path.includes("user/course/details")) {
      await this.getUserCourseDetail(this.$route.params.id);
      this.heartFill =
        this.userCourseDetail &&
        this.userCourseDetail.course &&
        this.userCourseDetail.course.details &&
        this.userCourseDetail.course.details.is_favourite;
      this.favouriteCount =
        this.userCourseDetail &&
        this.userCourseDetail.course &&
        this.userCourseDetail.course.details &&
        this.userCourseDetail.course.details.favourite_count;
    } else if (
      this.$router.currentRoute.path.includes("user/session/details")
    ) {
      await this.getUserSessionDetail(this.$route.params.id);
      this.heartFill =
        this.userSessionDetail &&
        this.userSessionDetail.session &&
        this.userSessionDetail.session.details &&
        this.userSessionDetail.session.details.is_favourite;
      this.favouriteCount =
        this.userSessionDetail &&
        this.userSessionDetail.session &&
        this.userSessionDetail.session.details &&
        this.userSessionDetail.session.details.favourite_count;
    }
    // await this.getCategoriesList();
    if (this.getToken()) {
      await this.getNotifications();
    }
    this.sumNotifications();
    const { type, filter } = this.$route.query;
    if (type) {
      this.searchType = type;
    }
    if (filter) {
      this.searchValue = filter;
    }
    if (this.$route.path === "/user/trainers/find") {
      this.searchType = "trainers";
    }
    if (this.$route.path === "/user/sessions/find") {
      this.searchType = "sessions";
    }
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style>
/* .tooltip .tooltiptext {
  top: 100%;
  margin-left: -60px;
} */
.tutorial-popper {
  white-space: nowrap;
}
.fc-today-button {
  background-color: white !important;
  color: black !important;
  padding: 5px 18px !important;
  text-transform: capitalize !important;
}
.fc-today-button:hover {
  background-color: #8dc73f !important;
  border-color: #8dc73f !important;
  color: white !important;
}
.fc-prev-button,
.fc-next-button {
  background-color: white !important;
  color: black !important;
  border-color: white !important;
}
.fc-toolbar-title {
  font-size: 24px !important;
}
.fc-dayGridMonth-button {
  padding: 5px 16px !important;
  text-transform: capitalize !important;
  background-color: white !important;
  color: black !important;
}
.fc-dayGridMonth-button:hover {
  background-color: #8dc73f !important;
  border-color: #8dc73f !important;
  color: white !important;
}
.fc-timeGridWeek-button {
  padding: 5px 20px !important;
  text-transform: capitalize !important;
  background-color: white !important;
  color: black !important;
}
.fc-timeGridWeek-button:hover {
  background-color: #8dc73f !important;
  border-color: #8dc73f !important;
  color: white !important;
}
.fc-timeGridDay-button {
  padding: 5px 27px !important;
  text-transform: capitalize !important;
  background-color: white !important;
  color: black !important;
}
.fc-timeGridDay-button:hover {
  background-color: #8dc73f !important;
  border-color: #8dc73f !important;
  color: white !important;
}
.fc-header-toolbar {
  background-color: white;
  margin-bottom: 0 !important;
  padding: 5px 10px;
  margin-top: 20px;
  border-radius: 5px;
}
.fc-timegrid-axis {
  margin: 10px 10px !important;
}
@media only screen and (max-width: 800px) {
  .fc-header-toolbar {
    margin-top: 20px;
    font-size: 7px !important;
  }
  .fc-toolbar-title {
    font-size: 20px !important;
  }
  .fc-today-button {
    padding: 5px 9px !important;
  }
  .fc-dayGridMonth-button {
    padding: 5px 8px !important;
  }
  .fc-timeGridWeek-button {
    padding: 5px 10px !important;
  }
  .fc-timeGridDay-button {
    padding: 5px 13px !important;
  }
}
@media only screen and (max-width: 767px) {
  .fc-header-toolbar {
    margin-top: 10px;
    font-size: 9px;
  }
}
.user-calendar .fc td,
.fc th {
  border: 1px solid var(--fc-border-color, #ddd);
  border-radius: 5px;
}
.user-calendar .fc-media-screen .fc-timegrid-event {
  border-width: 1px;
  border-left-width: 5px !important;
  border-radius: 5px !important;
}
.user-calendar .fc-header-toolbar {
  border: 1px solid lightgray;
}
.fc .fc-button-primary:active:focus {
  box-shadow: unset;
  outline: none;
}
.fc .fc-button-primary:focus {
  box-shadow: unset;
  outline: none;
}
.user-calendar .fc-timegrid-event .fc-event-main {
  display: flex;
  gap: 4px;
  align-items: center;
  padding-left: 3px;
  padding-right: 3px;
}
.user-calendar .fc-timegrid-event .fc-event-main img {
  height: 38px;
  width: 38px;
  border-radius: 5px;
}
.user-calendar .fc-v-event .fc-event-main-frame {
  height: max-content;
  overflow: hidden;
}
.user-calendar .fc-button-active {
  background-color: #8dc73f !important;
  border-color: #9ba195 !important;
  color: white !important;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>